import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
//import { FileBlob } from "./fileBlob.model";

import {AuthenticationService} from './index';
import {LoginHelper} from "../helpers";
import {Evidence} from "../_models/evidence";
import {Attachment} from "../_models";
import {AssessmentNoteAttachment} from "../_models/assessmentNoteAttachment";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {ActionPlanAttachment} from "../_models/actionPlanAttachment";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class FileBlobService {

    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }

  downloadFile(fileName, path: string): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/attachments/file?name='+ encodeURIComponent(fileName) + '&path='+ path, {responseType: 'arraybuffer'});
  }
  downloadFileByUrl(url: string): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + url, {responseType: 'arraybuffer'});
  }
  downloadWorkStreamFile(fileName, path: string): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/attachments/workstreamfile?name=' + encodeURIComponent(fileName) + '&path=' + path, { responseType: 'arraybuffer' });
  }

  @Load()
  postAttachment(projectName: string, entity: File, userId: string, projectControlItemId: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, projectControlItemId);

    return this.http
      .post<any>(this.config.api + '/api/attachments/attachment?projectName=' + projectName + '&userId=' + userId, formData)
      ;
  }
  @Load()
  postWorkStreamDocument(WorkStreamName: string, entity: File, userId: string, WorkStreamItemId: string, attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, WorkStreamItemId);

    return this.http
      .post<any>(this.config.api + '/api/attachments/workstreamitemdocument?workStreamName=' + WorkStreamName + '&userId=' + userId + '&attachmentId=' + attachmentId, formData)
      ;
  }

  @Load()
  postAssessmentAttachment(projectName: string, entity: File, userId: string, assessmentNoteId: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, assessmentNoteId);

    return this.http
      .post<any>(this.config.api + '/api/attachments/assessment?projectName=' + projectName + '&userId=' + userId, formData)
      ;
  }

  @Load()
  postActionPlanAttachment(projectName: string, entity: File, userId: string, actionPlanId: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, actionPlanId);

    return this.http
      .post<any>(this.config.api + '/api/attachments/actionPlan?projectName=' + projectName + '&userId=' + userId, formData)
      ;
  }

  @Load()
  postEvidence(entity: File, submitterId: string, projectName: string, projectControlItemId: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, projectControlItemId);

    return this.http
      .post<any>(this.config.api + '/api/attachments/evidence?projectName=' + projectName + '&submitterId=' + submitterId, formData)
      ;
  }
  @Load()
  updateEvidence(evidence: Evidence) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/attachments/evidence', evidence);
  }
  @Load()
  updateAttachment(attachment: Attachment) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/attachments/attachment', attachment);
  }
  @Load()
  updateWorkStreamAttachment(attachment: Attachment) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/attachments/workstreamattachment', attachment);
  }
  @Load()
  updateAssessmentAttachment(attachment: AssessmentNoteAttachment) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/attachments/assessment', attachment);
  }
  @Load()
  updateActionPlanAttachment(attachment: ActionPlanAttachment) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/attachments/actionPlan', attachment);
  }
  @Load()
  createEvidence(evidence) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/attachments/evidence/url', evidence)
      ;
  }
  @Load()
  deleteEvidence(evidenceId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/evidence/delete?evidenceId=' + evidenceId);
  }
  @Load()
  deleteAttachment(attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/delete?attachmentId=' + attachmentId);
  }
  @Load()
  deleteWorkStreamItemDocument(attachmentId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    return this.http
      .delete(this.config.api + '/api/attachments/workstreamitem/delete?attachmentId=' + attachmentId);
  }
  @Load()
  deleteAssessmentAttachment(attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/assessment/delete?attachmentId=' + attachmentId);
  }
  @Load()
  deleteActionPlanAttachment(attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/actionPlan/delete?attachmentId=' + attachmentId);
  }
  @Load()
  deleteIncidentResponseAttachment(attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/incidentResponse/delete?attachmentId=' + attachmentId);
  }
  @Load()
  postIncidentResponseAttachment(entity: File, incidentResponseId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, incidentResponseId.toString(10));

    return this.http
      .post<any>(this.config.api + '/api/attachments/incidentResponse?incidentResponseId=' + incidentResponseId, formData)
      ;
  }
  @Load()
  postDocumentRequestAttachment(entity: File, documentRequestId: number, RequestName: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, documentRequestId.toString(10));

    return this.http
      .post<any>(this.config.api + '/api/attachments/documentRequest?documentRequestId=' + documentRequestId + "&RequestName=" + RequestName, formData)
      ;
  }
  @Load()
  deleteDocumentRequestAttachment(attachmentId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/attachments/documentRequest/delete?attachmentId=' + attachmentId);
  }
}
